// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"042349c8","351":"882610d2","428":"3165d611","435":"10bff4a8","495":"4b3ea48e","514":"ca2e0d27","560":"cb36acfc","641":"06448baf","662":"cef4b4ea","774":"9c95db35","856":"6a9f894e","865":"3c50896e","897":"8990dc23"}[chunkId] + ".chunk.js";
};